<template>
  <div class="order-data">
    <div v-for="field in orderFields" :key="field" class="order-data__row">
      <span class="order-data__label">{{
        $t(`main.jobs.fields.${field}`)
      }}</span>
      <span class="order-data__value">
        {{ formatField(order[field], field) || "—" }}
      </span>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";

moment.locale("es");

export default {
  name: "OrderData",
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState("config", ["visibleFieldsOrdersDataVisor"]),

    orderFields() {
      const fields = Array.isArray(this.visibleFieldsOrdersDataVisor)
        ? this.visibleFieldsOrdersDataVisor
        : [];
      return fields.filter((field) => field !== "recorderId");
    },
  },
  methods: {
    formatField(value, fieldName) {
      if (fieldName === "videoStart" || fieldName === "videoEnd") {
        return moment(value).format("DD/MM/YYYY - HH:mm:ss");
      }
      if (fieldName === "createdAt") {
        return moment(value).format("DD/MM/YYYY");
      }
      if (Array.isArray(value)) {
        return value.join(", ");
      }
      const dateFields = ["createdAt", "updatedAt", "videoStart", "videoEnd"];
      if (dateFields.includes(fieldName)) {
        if (
          value instanceof Date ||
          moment(value, moment.ISO_8601, true).isValid()
        ) {
          return moment(value).format("HH:mm:ss");
        }
      }
      return value == null ? "" : String(value);
    },
  },
};
</script>

<style scoped>
.order-data {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.order-data__row {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.order-data__label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #0284c7;
}

.order-data__value {
  font-size: 13px;
  color: #0f172a;
}
</style>
